export default ({ store, redirect }) => {
  if (!store.state.member.auth.token) {
    // return redirect('/auth/login')
    return redirect('/')
  }
}
